import { createDecorator } from '../../instantiation/common/instantiation.js';
const IUserDataSyncAccountService = ( createDecorator('IUserDataSyncAccountService'));
export { IUserDataSyncAccountService };
